import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import ReactTable from 'react-table'
import "react-table/react-table.css";


import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class PendingQuotation extends Component {

    constructor(){
        super();
        this.view = this.view.bind(this)
        this.approved = this.approved.bind(this);
        this.disapproved = this.disapproved.bind(this);
        this.state = {
            userId:"",
            user :{},
            quotation: {}
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        });   
    }


    componentDidMount(){
        let quotation = ref.child("Quotation").orderByChild('status').equalTo('Pending');
            quotation.on("value", function(snap){
                this.setState({
                    quotation : snap.val()
                })
            }.bind(this))
    }

    approved(index){
        let quotation = this.state.quotation;
        if(window.confirm("Do you really want to approve this quotation")===true){
            Object.keys(quotation).map(key =>{
                let id = quotation[index] 
                if(id === quotation[key]){
                    let statusUpdate ={
                        checkBy : this.state.user.firstname,
                        checkByUserId : this.state.userId,
                        status : "Approved"
                    }
                    ref.child("Quotation").child(index).update(statusUpdate).then(()=>{
                        alert("Quotation has been approved ")
                    })// end of update in the firebase
                } // end of condition  
            } ) //end of loop
        }// end of window confirm
    }
    
    disapproved(index){
      let quotation = this.state.quotation;
        if(window.confirm("Do you really want to Disapprove this quotation")===true){
            Object.keys(quotation).map(key =>{
                let id = quotation[index] 
                if(id === quotation[key]){
                    let statusUpdate ={
                        checkBy : this.state.user.firstname,
                        checkByUserId : this.state.userId,
                        status : "Disapproved"
                    }
                    ref.child("Quotation").child(index).update(statusUpdate).then(()=>{
                        alert("Quotation has been Disapproved ")
                    })// end of update in the firebase
                } // end of condition  
            } ) //end of loop
        }// end of window confirm
    }

    view(index){
        window.location.assign("/quotation/"+index+"/view")
    }

    render() {
        var x = [];
        this.state.quotation &&
        Object.keys(this.state.quotation).map(key => {
            let list = this.state.quotation[key]
                list.id = key
                list.customer.name = list.customer.name.toUpperCase();
                list.customer.location = list.customer.location.toUpperCase();
                list.customer.representative = list.customer.representative.toUpperCase();
                list.status = list.status.toUpperCase();
            x.push(list)
            }) 
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Pending Quotation" />
                            <div className="block">
                                <ReactTable
                                    data={x}
                                    columns={[
                                        {
                                            Header: "Quotaion Number",
                                            accessor : "id"
                                        },
                                        {
                                            Header: "Customer Name",
                                            accessor : "customer.name",
                                            filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                        },
                                        {
                                            Header: "Address",
                                            accessor : "customer.location",
                                            filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                        },
                                        {
                                            Header: "Sales Representative",
                                            accessor : "customer.representative",
                                            filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                        },
                                        {
                                            Header: "Status",
                                            accessor : "status",
                                            filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                        },
                                        {
                                            Header: 'Action',
                                            accessor : "id",
                                            Cell : row => (
                                                <span>
                                                <button onClick={()=>this.approved(row.value)}><i className="fa fa-check"></i></button>
                                                <button onClick={()=>this.disapproved(row.value)}><i className="fa fa-times"></i></button>
                                                <button onClick={()=>this.view(row.value)}><i className="fa fa-eye"></i></button>                                                
                                                </span>
                                            )
                                                                               
                                        }
                                    ]}
                                    
                                    filterable ={true}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                />                                 
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default PendingQuotation;



// WEBPACK FOOTER //
// ./src/components/PendingQuotation.js